// extracted by mini-css-extract-plugin
export default {"authorLinkContainer":"AuthorLink-module__authorLinkContainer__h8OXS3j","authorNameLink":"AuthorLink-module__authorNameLink__Bjd3dlo"};